import _ from 'lodash';

export default {
  computed: {
    blogItem() {
      return this.$store.state.blogItem;
    },
    blogItemRevisions() {
      return this.$store.state.blogItemRevisions;
    },
    selectedRevision() {
      return _.find(this.blogItemRevisions, { selected: true });
    },
    blogHidden: {
      get() {
        return this.$store.state.blogItem.hidden === 'true';
      },
      set(hidden) {
        this.$store.state.blogItem.hidden = hidden
          ? 'true'
          : 'false';
      },
    },
  },
  methods: {
    selectRevision(revision) {
      _.each(this.blogItemRevisions, (rev) => {
        this.$set(rev, 'selected', false);
      });

      this.$set(revision, 'selected', true);
    },
    createBlogItem() {
      this.$store.dispatch('createBlogItem')
        .then(() => {
          this.goToBlogList();
        });
    },
    updateBlogItem() {
      this.$store.dispatch('updateBlogItem')
        .then(() => {
          this.goToBlogList();
        });
    },
    updateActiveBlogItemVersion() {
      this.$store.dispatch('updateActiveBlogItemVersion', this.selectedRevision)
        .then(() => {
          this.goToBlogList();
        });
    },
  },
};
